export default "__VITE_ASSET__feb44c53__"